export function createCategoriesApi(http) {
  return {
    list: () => http.get('/api/categories'),
    create: (body) => http.post('/api/categories', body),
    patch: (id, body) => http.patch(`/api/categories/${id}`, body),
    // `reassignTo` is the owner's answer to "what happens to the goals filed under this?".
    // Omitted, the server clears the category off them; with an id, it moves them there
    // first. Never a cascade that takes the goals with it.
    remove: (id, { reassignTo } = {}) =>
      http.del(
        reassignTo === undefined || reassignTo === null
          ? `/api/categories/${id}`
          : `/api/categories/${id}?reassignTo=${encodeURIComponent(reassignTo)}`
      ),
    reorder: (order) => http.patch('/api/categories/reorder', { order }),
  }
}
